import { apiClient } from './client'

export interface EnumOption {
  value: string
  label: string
  color?: string
}

export type EnumsResponse = Record<string, EnumOption[]>

/**
 * Загружает все enum'ы с переводами с бэкенда.
 * Локаль передаётся через заголовок Accept-Language (выставляется в apiClient из i18n.language).
 */
export async function getEnums(): Promise<EnumsResponse> {
  const { data } = await apiClient.get<EnumsResponse>('/enums')
  return data
}
